import { replace } from 'lodash';

const pathUuidMatcher = new RegExp(
  `/+[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12}`,
  'g',
);

const pathIdMatcher = new RegExp(`/+\\d+`, 'g');

export const parsePathForIdentifiers = (path: any) => {
  const pathParsedForUuids = replace(path, pathUuidMatcher, '/{uuid}');
  const pathParsedForIds = replace(pathParsedForUuids, pathIdMatcher, '/{id}');

  return pathParsedForIds;
};
